<template>
  <div class="bg-gray-100 p-4">
    <FormulateForm class="login-form flex-col flex" v-model="values">
      <div class="grid grid-cols-1 border border-black border-dashed mt-4 p-2">
        <FormulateInput
          type="group"
          name="cards"
          :repeatable="true"
          label="Kaarten"
          label-class="font-raleway font-bold text-xl text-mi-blue-500 uppercase"
          add-label="+ Kaart toevoegen"
          remove-label="Kaart verwijderen"
          remove-label-class="font-hairline"
          wrapper-class="flex-col flex"
          validation="min:1"
          :validation-messages="{ min: 'Minimaal 1 kaart toevoegen' }"
          #default="{ index: cardindex }"
        >
          <div class="mt-4 p-4">
            <FormulateInput
              name="cardname"
              type="text"
              label="Kaartnaam *"
              placeholder="Naam kaart"
              input-class="mi-input"
              label-class="mi-label"
              wrapper-class="flex-col flex"
              validation="required"
              :validation-messages="{ required: 'Kaartnaam is verplicht' }"
            />
          </div>

          <FormulateInput
            type="group"
            name="flexprops"
            :repeatable="true"
            label="Flexprops"
            label-class="font-raleway font-bold text-xl text-mi-blue-500 uppercase"
            add-label="+ Flexprop toevoegen"
            remove-label="Flexprop verwijderen"
            remove-label-class="font-hairline"
            wrapper-class="flex-col flex"
            validation="min:1"
            :validation-messages="{ min: 'Minimaal 1 flexprop toevoegen' }"
            #default="{ index: flexpropindex }"
          >
            <div class="mt-4 p-4">
              <FormulateInput
                name="id"
                type="text"
                label="id (automatisch gegenereerd)"
                input-class="mi-input disabled"
                label-class="mi-label"
                wrapper-class="flex-col flex"
                :disabled="true"
              />
              <FormulateInput
                name="flexpropname"
                type="text"
                label="Variabele naam *"
                placeholder="variabele_naam"
                input-class="mi-input"
                label-class="mi-label"
                wrapper-class="flex-col flex"
                validation="required|matches:/^[a-z_]+$/"
                :validation-messages="{
                  required: 'Variabelenaam is verplicht',
                  matches:
                    'Variabelenaam mag alleen lowercase letters of _ bevatten'
                }"
              />
              <FormulateInput
                name="flexproplabel"
                type="text"
                label="Label *"
                placeholder="Label"
                input-class="mi-input"
                label-class="mi-label"
                wrapper-class="flex-col flex"
                validation="required"
                :validation-messages="{
                  required: 'Label is verplicht'
                }"
              />
              <FormulateInput
                type="select"
                name="flexproptype"
                validation="required"
                value="onbekend"
                input-class="mi-input"
                label-class="mi-label"
                :options="flexproptypes"
                label="Type flexprop *"
                :validation-messages="{
                  required: 'Type flexprop is verplicht'
                }"
              />
              <div
                v-if="selectedTypeIsOfVar(cardindex, flexpropindex, 'number') || selectedTypeIsOfVar(cardindex, flexpropindex, 'integer')"
              >
                <FormulateInput
                  type="group"
                  name="options"
                  label="Opties"
                  label-class="font-raleway font-bold text-xl text-mi-blue-500 uppercase"
                  wrapper-class="flex-col flex"
                >
                  <FormulateInput
                    type="number"
                    name="minimum"
                    label="Minimum"
                  />
                  <FormulateInput
                    type="number"
                    name="maximum"
                    label="Maximum"
                  />
                </FormulateInput>
              </div>
            </div>
          </FormulateInput>
        </FormulateInput>
      </div>
    </FormulateForm>
    <div class="mt-2">
      <button
        @click="updateDomeinlijst()"
        class="ml-2 mb-4 bg-gray-100  text-blue-700 font-semibold  py-2 px-4 border border-mi-blue-400 rounded hover:bg-mi-blue-400 hover:text-white hover:border-transparent;"
      >
        Opslaan
      </button>

      <button
        @click="checkFlexprops()"
        class="ml-2 mb-4 bg-gray-100  text-blue-700 font-semibold  py-2 px-4 border border-mi-blue-400 rounded hover:bg-mi-blue-400 hover:text-white hover:border-transparent;"
      >
        Check
      </button>

      <button
        @click="applyFlexprops()"
        class="ml-2 mb-4 bg-gray-100  text-blue-700 font-semibold  py-2 px-4 border border-mi-blue-400 rounded hover:bg-mi-blue-400 hover:text-white hover:border-transparent;"
      >
        Toepassen
      </button>

      <button
        class="ml-2 mb-4 bg-gray-100  text-blue-700 font-semibold  py-2 px-4 border border-mi-blue-400 rounded hover:bg-mi-blue-400 hover:text-white hover:border-transparent;"
        @click="parseSchemaToForm(schema_current)"
      >
        Kopieer huidig schema
      </button>
    </div>
    {{ msg }}
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
export default {
  name: "SuggestFlexPropsSchema",
  props: ["voorziening_type"],
  data() {
    return {
      values: {},
      suggested_schema_present_at_load: false,
      schema_suggested: this.voorziening_type.flexprop_schema_suggested,
      schema_current: this.voorziening_type.flexprop_schema_current,
      flexproptypes: [
        { id: 1, label: "tekst", value: "string" },
        { id: 4, label: "getal met decimaal", value: "number" },
        { id: 2, label: "geheel getal", value: "integer" },
        { id: 3, label: "checkbox", value: "boolean" },
        
      ],
      msg: null
    };
  },

  methods: {
    selectedTypeIsOfVar: function(cardindex, flexpropindex, type) {
      if (flexpropindex === undefined) return false;
      if (!("cards" in this.values)) return false; // if we remove this, the interface acts up

      return (
        this.values.cards[cardindex].flexprops[flexpropindex].flexproptype ===
        type
      );
    },
    parseFormToSchema: function() {
      let properties = {};

      for (const card of this.values.cards) {
        for (const flexprop of card.flexprops) {
          const id = flexprop.id ? flexprop.id : uuidv4();
          properties[flexprop.flexpropname] = {
            id: id,
            label: flexprop.flexproplabel,
            type: flexprop.flexproptype,
            card: card.cardname
          };

          if (!flexprop.options) continue;
          if (!flexprop.options[0]) continue;

          properties[flexprop.flexpropname] = {
            ...properties[flexprop.flexpropname],
            ...flexprop.options[0]
          };
          if ("minimum" in properties[flexprop.flexpropname]) {
            if (flexprop.flexproptype=="number") {
               properties[flexprop.flexpropname].minimum = parseFloat(properties[flexprop.flexpropname].minimum)
            } else {
                properties[flexprop.flexpropname].minimum = parseInt(properties[flexprop.flexpropname].minimum)
            }
          }
          if ("maximum" in properties[flexprop.flexpropname]) {
            if (flexprop.flexproptype=="number") {
               properties[flexprop.flexpropname].maximum = parseFloat(properties[flexprop.flexpropname].maximum)
            } else {
                properties[flexprop.flexpropname].maximum = parseInt(properties[flexprop.flexpropname].maximum)
            }
          }
        }
      }

      return {
        type: "object",
        properties: properties,
        additionalProperties: false
      };
    },
    parseSchemaToForm: function(schema) {
      const cardnames = Object.values(schema.properties).reduce(
        (cardnames, item) => {
          if (!cardnames.includes(item.card)) {
            cardnames.push(item.card);
          }
          return cardnames;
        },
        []
      );

      let values_out = [];
      for (const cardname of cardnames) {
        const properties = Object.entries(schema.properties).filter(([_, v]) =>
          cardname.includes(v.card)
        );

        let flexprops = [];
        for (const [key, value] of properties) {
          let options = Object.fromEntries(
            Object.entries(value).filter(
              ([k, _]) => !["id", "type", "label", "card"].includes(k)
            )
          );
          flexprops.push({
            id: value["id"],
            flexproptype: value["type"],
            flexproplabel: value["label"],
            flexpropname: key,
            options: [options]
          });
        }
        values_out.push({ cardname, flexprops });
      }

      this.values = { cards: values_out };
    },
    updateDomeinlijst: async function() {
      let new_voorziening_type = this.voorziening_type;
      new_voorziening_type.flexprop_schema_suggested = this.parseFormToSchema();
      const [ok, msg] = await this.$store.dispatch("updateDomeinlijst", {
        name: "voorziening_typen",
        properties: new_voorziening_type
      });
      if (ok) {
        this.msg = "Gegevens succesvol opgeslagen";
      } else {
        this.msg = msg;
      }
      return ok;
    },
    checkFlexprops: async function() {
      await this.updateDomeinlijst();
      const [ok, msg] = await this.$store.dispatch("checkFlexprops", {
        id: this.voorziening_type.id
      });
      if (ok) {
        this.msg = "Check verzonden. Check uw e-mail voor de resultaten.";
      } else {
        this.msg = msg;
      }
    },
    applyFlexprops: async function() {
      await this.updateDomeinlijst();
      const [ok, msg] = await this.$store.dispatch("applyFlexprops", {
        id: this.voorziening_type.id
      });
      if (ok) {
        this.msg = "Verzoek verzonden. Check uw e-mail voor de resultaten.";
      } else {
        this.msg = msg;
      }
    }
  },
  created: function() {
    this.suggested_schema_present_at_load = Boolean(this.schema_suggested);
    if (
      this.schema_suggested &&
      Object.keys(this.schema_suggested).length > 0
    ) {
      this.parseSchemaToForm(this.schema_suggested);
    } else {
      this.parseSchemaToForm(this.schema_current);
    }
  }
};
</script>

<style>
.mi-input {
  @apply border-gray-500 border rounded-sm px-2 py-1 w-full;
}

.mi-label {
  @apply text-sm font-bold;
}

.formulate-input-group-repeatable {
  @apply border-gray-500 border border-dashed m-4 p-4 bg-gray-200;
}

.formulate-input-group-repeatable-remove {
  @apply ml-2 mb-4 bg-gray-100  text-red-600 font-semibold  py-2 px-4 border border-red-400 rounded;
}

.formulate-input-group-repeatable-remove:hover {
  @apply bg-red-600 text-white border-transparent;
}

.formulate-input-element--button--label {
  @apply ml-2 mb-4 bg-gray-100  text-blue-700 font-semibold  py-2 px-4 border border-mi-blue-400 rounded;
}
.formulate-input-element--button--label:hover {
  @apply bg-mi-blue-400 text-white border-transparent;
}
</style>
